import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styles from "../../../SearchWidget.module.scss";
import {refBlur, refFocus} from "../../../../../tools/tools";
import shiftAware from "../../../../../hoc/ShiftAware/ShiftAware";
import animations from '../../../../../assets/scss/animations/animate.module.scss';

const MultiCityAddRemoveBtn = ({contRef, prevRef, nextRef, clickHandler, disabled, children, shiftPressed, animated, hidden, title, ...props}) => {

    const [animationClasses, setAnimationClasses] = useState('');

    const classes = [styles.btnAddOrRemoveLeg, animationClasses];
    if (disabled) classes.push(styles.btnAddOrRemoveLegDisabled);
    if (hidden) classes.push(styles.btnAddOrRemoveLegInvisible);
    if (animated) classes.push(animationClasses);

    const localClickHandler = () => {
        if (animated && (disabled || hidden)) {
            setAnimationClasses(`${animations.animated} ${animations.shake}`);
            setTimeout(() => setAnimationClasses(''), 500);
            return;
        }

        clickHandler();
        if (animated) {
            setAnimationClasses(`${animations.animated} ${animations.touchEffect}`);
            setTimeout(() => setAnimationClasses(''), 500);
        }
    };

    const keyDownHandler = e => {
        const code = e.code ? e.code : e.key;

        if (code === 'Tab' && shiftPressed) {
            refBlur(contRef);
            refFocus(prevRef);
            e.stopPropagation();
            e.preventDefault();
            return;
        }

        switch (code) {
            case 'Left':
            case 'ArrowLeft':
                refBlur(contRef);
                refFocus(prevRef);
                break;
            case 'Right':
            case 'ArrowRight':
            case 'Tab':
                refBlur(contRef);
                refFocus(nextRef);
                break;
            case 'Escape':
                refBlur(contRef);
                break;
            case ' ':
            case 'Space':
            case 'NumpadEnter':
            case 'Enter':
                localClickHandler(e);
                break;
            default:
                return;
        }

        e.preventDefault();
        e.stopPropagation();
    };

    return (
        <div ref={contRef}
             tabIndex={0}
             title={title}
             onKeyDown={keyDownHandler}
             className={classes.join(' ')}
             onClick={localClickHandler}>
            {children}
        </div>
    );
};

MultiCityAddRemoveBtn.propTypes = {
    clickHandler: PropTypes.func,
    contRef: PropTypes.any,
    prevRef: PropTypes.any,
    nextRef: PropTypes.any,
    title: PropTypes.string,
    shiftPressed: PropTypes.bool,
    disabled: PropTypes.bool,
    hidden: PropTypes.bool,
    animated: PropTypes.bool,
};

MultiCityAddRemoveBtn.defaultProps = {
    clickHandler: () => null,
    contRef: null,
    prevRef: null,
    nextRef: null,
    title: '',
    shiftPressed: false,
    disabled: false,
    hidden: false,
    animated: false
};

export default shiftAware(MultiCityAddRemoveBtn);
